import Header from '../components/Header';
import CreateForm from './components/CreateForm';

function CreateOffer() {

    let pagesLinks = [

        {
            name: "إنشاء عرض",
            link: `/admin/offers/create`,
        },
        { name: "الصفحة الرئيسية", link: `/` },
    ];


    return (
        <>
            <Header pageName="إنشاء عرض" pages={pagesLinks} className="text-2xl" />

            <CreateForm />
        </>
    )
}

export default CreateOffer